import BucketApiRequest from "./BucketApiRequest";
import { GET_BENEFICIARY_RELATION_URL } from "../ApiUrls";

export default class GetBeneficiaryRelationApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_BENEFICIARY_RELATION_URL;
  };
}
